<template>
<v-main>
  <v-container>
    <v-row>
      <v-col>
        <v-card flat class='settings-card mb-5' style='border: 3px solid #292961' :loading="(instantCreating || conferenceLoading)" v-if="!this.instantConference.conference_id">
          <v-card-title>Start an instant conference</v-card-title>
          <v-card-actions>
            <v-btn elevation='0' color="info" v-on:click="createInstantConference()" v-if="!(instantCreating || conferenceLoading)">New conference</v-btn>
          </v-card-actions>
        </v-card>

        <v-card flat class='settings-card mb-5' style='border: 3px solid #292961' v-if="this.instantConference.conference_id" :loading="(instantCreating || conferenceLoading)">
          <v-card-title>Your instant conference is ready</v-card-title>
          <v-card-text>
            <span v-html="getJoinInfoWeb(this.instantConference)"></span>
          </v-card-text>
          <v-card-actions>
            <v-btn elevation='0' color="info" v-on:click="enterInstantConference()" v-if="!(instantCreating || conferenceLoading)">Enter Conference</v-btn>
          </v-card-actions>
        </v-card> 
      <template v-if="showConferenceLines">    
        <v-card :loading="conferenceLoading" flat class='settings-card' style='border: 3px solid #292961'>
          <template slot="progress">
            <v-progress-linear
              color="accent"
              height="5"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-title>Conference Lines</v-card-title>
          <v-list>
            <v-list-item one-line v-for="conference in savedConferences" :key="conference.conference_id">
              <v-list-item-avatar>
                      <v-icon v-if="(activeConferenceId && (conference.conference_id == activeConferenceId))">mdi-account-group-outline</v-icon>
              </v-list-item-avatar>
              
              <v-list-item-title v-on:click="setConference(conference)">
                {{conference.name}}
              </v-list-item-title>
              <v-spacer></v-spacer>
            </v-list-item>
          </v-list>
          <v-card-actions>
             <v-btn
                elevation='0'
                v-on:click="$router.push('/newconference')"
                color="info"
                v-if="!(instantCreating || conferenceLoading)"
              >
                New Conference Line
              </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      </v-col>
    </v-row>
  </v-container>



</v-main>
</template>



<script >
import { mapState } from 'vuex';
import Common from '../mixins/common.vue';
import ConferenceCommon from '../mixins/conferencecommon.vue';

export default {
  data: function() {
    return {
      showConference: false,
      instantCreating: false,
    }
  },
  mixins: [Common, ConferenceCommon],
  props: {
  },
  computed: {
    ...mapState([

      'deviceId',
      'device', 
      'isDevelopment',
      'number',
      'user',
      'userId',
    ]),
    instantConference: {
      get: function() {
        return this.$store.state.conference.instantConference;
      }
    },
    conferences: {
      get: function() {
        return this.$store.state.conference.conferences;
      }
    },
    savedConferences: function() {
      let arr = [];
      for (let i=0;i<this.conferences.length;i++) {
        let c = this.conferences[i];
        if (c.instant != 'Y') {
          console.log(c.name + ' put savedConference when instant was -' + c.instant + '-')
          arr.push(c);
        }
      }
      return arr;
    },
    instantConferences: function() {
      let arr = [];
      for (let i=0;i<this.conferences.length;i++) {
        let c = this.conferences[i];
        if (c.instant == 'Y') {
          arr.push(c);
        }
      }
      return arr;
    },
    conferenceLoading: {
      get: function () {
        return this.$store.state.conference.conferenceLoading;
      }
    },
    showConferenceLines: function() {
      if (!this.showConference) {
        if (!this.showAddConference) {
          return true;
        }
      }
      return false;
    },
    
  },
  components: {
  },
  methods: {
    showModal: function(name) {
      this.$modal.show(name);
    },
    hideModal: function(name) {
      this.$modal.hide(name);
    },
    setConference: function(c) {
      this.conf = c;
      // somehow this takes the first element or c.AdminPins
      // is not an array like I am expecting. Works for now.
      // I thought I would have to do a
      // this.adminPPin = c.AdminPins[0];  wierd
      this.adminPin = c.AdminPins;
      this.guestPin = c.GuestPins;
      
      this.$router.push('/conference/' + this.getBestGuestPin(c))
    },
    enterInstantConference: function() {
      this.$router.push('/conference/' + this.getBestGuestPin(this.instantConference));
    },
    confColor: function(conference) {
      if (conference.conference_id == this.activeConferenceId) {
        return '#00008B'; // dark blue
      } else {
        return 'primary'
      }
    },
    createInstantConference: async function() {
      this.instantCreating = true;
      let result = await this.$http.get(
        global.apiurl + "/conference/create&" +
          "token=" + encodeURIComponent(this.click2call) +
          "&name=" + encodeURIComponent('Instant Conference') +
          "&companyAccess=false" +  
          "&conferenceType=Meeting" +
          "&instant=Y"
      );
      let conferenceId = result.body.conference_id;
      await this.$store.dispatch('conference/getConference', conferenceId);
      this.instantCreating = false;
    },
  },
  mounted() {
    global.api.userAction('conferences_read', null, 'webphone');
  }
};

</script>

<style scoped>

div[class*="col-"] {
  background: #fff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.row {
  margin-bottom: 0px;
}
</style>
